import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

const CustomChevronIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    {/* Downward chevron */}
    <path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z' />
  </SvgIcon>
);

export default CustomChevronIcon;
